import type { Selection, SingleOpportunity } from '../../types/betSlip';

import { isAvailableOpportunity } from './isOpportunity';

export const getSelectionsFromSingleOpportunities = (singles: SingleOpportunity[]): Selection[] =>
  singles.map((opportunity) => ({
    selectionId: opportunity.runnerId.selectionId,
    marketId: opportunity.runnerId.marketId,
    eventId: opportunity.eventId,
    legType: isAvailableOpportunity(opportunity) ? opportunity.legCombinations[0].legType : ''
  }));
